var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"date-container date-cell"},[_vm._v(" "+_vm._s(_vm.formatDate(_vm.value))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }